import _ from 'lodash';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { Subject } from 'rxjs';
import { first, map, takeUntil } from 'rxjs/operators';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import 'datatables.net-buttons-dt';
import { VolunteerActionCellComponent } from '../volunteer-action-cell/volunteer-action-cell.component';
import { DataTableDirective } from 'angular-datatables';
import { ToastService } from 'app/toast/services/toast.service';
import { VolunteerService } from 'app/volunteers/services/volunteer/volunteer.service';
import { AddVolunteerModalService } from 'app/volunteers/services/add-volunteer-modal/add-volunteer-modal.service';
import { VolunteerListService } from 'app/volunteers/services/volunteer-list/volunteer-list.service';
import { VolunteerStatusCellComponent } from '../volunteer-status-cell/volunteer-status-cell.component';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-volunteer-list',
  templateUrl: './volunteer-list.component.html',
  styleUrls: ['./volunteer-list.component.scss']
})
export class VolunteerListComponent implements OnInit, AfterViewInit, OnDestroy {

  @HostListener('click', ['$event'])
  onClick(event) {
    const isAddNewVolunteer = this.isDelegateElement(event, 'addNewVolunteer');
    if(isAddNewVolunteer) {
      return this.addVolunteer();
    }
  }
  
  @Input() readonly: boolean = false;

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();

  @ViewChild(DataTableDirective, {static: false})
  public dtElement: DataTableDirective;

  public dtOptions: ADTSettings = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();

  @ViewChild('volunteerActionCell') volunteerActionCell: TemplateRef<VolunteerActionCellComponent>;
  @ViewChild('volunteerStatusCell') volunteerStatusCell: TemplateRef<VolunteerStatusCellComponent>;
  
  public volunteerList: any [] = [];

  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService,
    private volunteerService: VolunteerService,
    private volunteerListService: VolunteerListService,
    private addVolunteerModalService: AddVolunteerModalService,
    private toastService: ToastService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    const self = this;

    let filter = 'all';
    let filterLabel = 'All';

    this.dtOptions = {
      ajax: (dataTablesParameters: any, callback) => {
        this.volunteerListService.getVolunteerList().pipe(
          map(response => {
            return _.map(response, volunteer => {
              return {
                ...volunteer,
                status: this.getVolunteerStatusString(volunteer)
              }
            }).filter((volunteer) => {
              const isActive = volunteer.volunteerStatus == 1 && volunteer.userStatus == 0;
              switch(filter) {
                case 'all':
                  return true;
                case 'active':
                  return isActive;
                case 'pending':
                  return !isActive;
                default:
                  return false;
              }
            });
          })
        ).subscribe((response: any[]) => {
          this.volunteerList = response;

          callback({
            recordsTotal: response.length,
            data: response
          });
        })
      },
      dom: "<'table__header--paybee d-flex align-items-center justify-content-between pb-3 pt-3'<''B><'d-flex align-items-center'<'#volunteers-filter-wrapper.cursor--pointer mr-2'><''f>>><'table-responsive't><'table__footer--paybee d-flex align-items-center justify-content-between p-4'ip>",
      buttons: [{
          className: 'btn-copy-code btn btn-outline-grey btn-sm px-2 waves-effect',
          extend: 'excel',
          filename: 'adminList',
          text: "<i class='fas fa-cloud-download-alt mr-1'></i> Export",
          title: null,
          exportOptions: {
              stripHtml: true,
              columns: "thead th:not(.no-export)"
          }
      }],
      columns: [
        {
            "data": "name",
            "width": "30%"
        },
        {
            "data": "email",
            "width": "30%"
        },
        {
            "data": null,
            "width": "15%",
            "defaultContent": '',
            "ngTemplateRef": {
                "ref": this.volunteerStatusCell,
            }
        }
      ],
      destroy: true,
      drawCallback: () => {
        const $ = window['$'];

        $("#volunteers-filter-wrapper").html(`<button type="button" data-toggle="dropdown" class="campaign__action btn btn--paybee btn--outline-transparent caption dropdown-toggle px-3 py-2" style="border: 1px solid #D8D8D8; background: transparent; border-radius: 4px;">
            <i class="fas fa-filter mr-1"></i>
            <span class="mr-1" id="volunteers-filter-label">${filterLabel}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right">
            <li class="dropdown-item cursor--pointer body-1 ${filter === 'all' ? 'active': ''}" data-label="All"><a>All</a></li>
            <li class="dropdown-item cursor--pointer body-1 ${filter === 'active' ? 'active': ''}" data-label="Active"><a>Active</a></li>
            <li class="dropdown-item cursor--pointer body-1 ${filter === 'pending' ? 'active': ''}" data-label="Pending"><a>Pending</a></li>
          </ul>`);

        $("#volunteers-filter-wrapper").off("click");
        $("#volunteers-filter-wrapper").on("click", ".dropdown-item", (event) => {
          const { currentTarget } = event;
          const label = $(currentTarget).data("label");
          $("#volunteers-filter-label").text(label);

          switch(label) {
            case 'All':
              filter = 'all';
              break;
            case 'Active':
              filter = 'active';
              break;
            case 'Pending':
              filter = 'pending';
              break;
          }

          filterLabel = label;
          this.updateDatatable()
        });
      }
    }

    if(!this.readonly) {
      this.dtOptions.columns.push({
        "data": null,
        "width": "15%",
        "defaultContent": '',
        "ngTemplateRef": {
          "ref": this.volunteerActionCell,
          "context": {
              // needed for capturing events inside <ng-template>
              captureEvents: this.onCaptureEvent.bind(this)
            }
        }
      })
    }

    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      this.dtTrigger.next(this.dtOptions);
    }, 200);
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

  addVolunteer() {
    const modalRef = this.addVolunteerModalService.open(null);
    return modalRef.onClose.pipe(
      first()
    ).subscribe(message => {
      if(message) {
        this.updateDatatable();
      }
    });
  }

  onClickImport() {
    const action = DialogActions.openDialog({
      payload: {
        name: "importVolunteers",
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          volunteerList: this.volunteerList,
          callback: (result) => {
            if(result) {
              this.updateDatatable();
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  onCaptureEvent(event) {
    const { data: { id, userId } } = event;

    switch(event.cmd) {
      case "delete": {
        return this.volunteerService.delete(id).pipe(
          takeUntil(this.takeUntilSubject)
        ).subscribe(() => {
          this.toastService.showSuccess("Volunteer Deleted");
          this.updateDatatable();
        });
      }
      case "resend": {
        return this.volunteerService.resend(userId).pipe(
          takeUntil(this.takeUntilSubject)
        ).subscribe(() => {
          this.toastService.showSuccess("Volunteer email notification sent.");
          this.updateDatatable();
        });
      }
    }
  }

  updateDatatable () {
    this.dtElement.dtInstance.then(dtInstance => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(null);
    });
  }

  getVolunteerStatusString(volunteer) {
    switch(volunteer.volunteerStatus) {
      case 1:
        if(volunteer.userStatus == 0) {
          return "Active"
        } else {
          return "Pending"
        }
      case 2:
        return "Pending"
      case 3:
        return "Deleted"
      default:
        return "Unknown"
    }
  }

  isDelegateElement(event, id) {
    let target: HTMLElement = event.target;
    while(target) {
      if(target.id === id) {
        return true;
      }
      target = target.parentElement;
    }
    return false;
  }
}
